import { render } from "./PlanningHero.vue?vue&type=template&id=2be57ec0&scoped=true"
import script from "./PlanningHero.vue?vue&type=script&lang=js"
export * from "./PlanningHero.vue?vue&type=script&lang=js"

import "./PlanningHero.vue?vue&type=style&index=0&id=2be57ec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be57ec0"]])

export default __exports__